/**
 * Bridge so slash / paste / drop can kick off uploads without threading
 * DocEditor refs through every call site.
 *
 * Also keeps the File around after a failed upload so Retry can re-send
 * without asking the user to pick the same image again.
 */

let starter = null;

/** @type {Map<string, File>} */
const pendingFiles = new Map();

/** @param {(blockId: string, file: File) => void} fn */
export const registerDocImageUploadStarter = (fn) => {
  starter = fn;
};

export const rememberPendingDocImageFile = (blockId, file) => {
  if (!blockId || !file) return;
  pendingFiles.set(blockId, file);
};

export const clearPendingDocImageFile = (blockId) => {
  if (!blockId) return;
  pendingFiles.delete(blockId);
};

export const hasPendingDocImageFile = (blockId) =>
  Boolean(blockId && pendingFiles.has(blockId));

export const startDocImageUpload = (blockId, file) => {
  if (!blockId || !file) return;
  rememberPendingDocImageFile(blockId, file);
  starter?.(blockId, file);
};

/** Re-run upload using the File kept from the last attempt. */
export const retryDocImageUpload = (blockId) => {
  const file = blockId ? pendingFiles.get(blockId) : null;
  if (!file) return false;
  starter?.(blockId, file);
  return true;
};
